import { render } from "./performance.vue?vue&type=template&id=53e94eb5"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"

import "./performance.vue?vue&type=style&index=0&id=53e94eb5&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__